module.exports = __webpack_public_path__ + "static/media/imaging-the-molecules-of-life.8d1fb66c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/imaging-the-molecules-of-life.png
// module id = 1484
// module chunks = 0